export const isHLS = url => url.includes('m3u')
